"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItemAligns = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("../../protons/typography/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    listItem: _defineProperty({
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 16,
      paddingBottom: 16
    }, theme.breakpoints.down("xs"), {
      paddingLeft: 16,
      paddingRight: 16
    }),
    startAdornment: {
      minWidth: "auto",
      marginRight: 20
    },
    endAdornment: {
      minWidth: "auto",
      marginLeft: 20
    },
    listItemText: {
      margin: 0
    },
    top: {
      alignItems: "flex-start"
    },
    center: {
      alignItems: "center"
    },
    bottom: {
      alignItems: "flex-end"
    }
  };
});
/**
 * ** Lists are continuous, vertical indexes of text or images. **
 *
 * There are 3 ways in which lists can be grouped:
 *
 * - Card - Individual
 *
 * - Card - Group
 *
 * - Card - Background
 *
 * ** Overrides **
 *
 * When you drag the list components into Sketch, override options will be available to create many variations.
 *
 * **Note:** To change a text style you may need to drag the desired style from Source into your document first, before you try to change the style within the list component.
 *
 */

var ListItem = function ListItem(_ref) {
  var _classNames;

  var primary = _ref.primary,
      secondary = _ref.secondary,
      intro = _ref.intro,
      footerNote = _ref.footerNote,
      startAdornment = _ref.startAdornment,
      endAdornment = _ref.endAdornment,
      align = _ref.align,
      selected = _ref.selected,
      heading = _ref.heading,
      action = _ref.action,
      component = _ref.component,
      to = _ref.to;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    disableRipple: heading,
    disableTouchRipple: heading,
    button: action,
    onClick: function onClick() {
      return action && action();
    },
    component: component,
    to: to,
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.listItem, true), _defineProperty(_classNames, styles[align], true), _classNames))
  }, startAdornment && /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, {
    className: (0, _classnames.default)(_defineProperty({}, styles.startAdornment, true))
  }, startAdornment), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    className: (0, _classnames.default)(_defineProperty({}, styles.listItemText, true)),
    disableTypography: true
  }, intro && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: intro,
    color: "Anthracite",
    variant: "footerNote"
  }), primary && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: primary,
    regular: !selected,
    variant: heading ? "h3" : "h5",
    bold: selected
  }), secondary && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: secondary,
    variant: "body"
  }), footerNote && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: footerNote,
    color: "Anthracite",
    variant: "footerNote"
  })), endAdornment && /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, {
    className: (0, _classnames.default)(_defineProperty({}, styles.endAdornment, true))
  }, endAdornment));
};

ListItem.propTypes = {
  /** The primary text of the list item */
  primary: _propTypes.default.string,

  /** The secondary text of the list item */
  secondary: _propTypes.default.string,

  /** The intro text of the list item */
  intro: _propTypes.default.string,

  /** The footernote text of the list item */
  footerNote: _propTypes.default.string,

  /** The start adorment component */
  startAdornment: _propTypes.default.element,

  /** The end adorment component */
  endAdornment: _propTypes.default.element,

  /** The flex alignment of the items (start,text,end)  */
  align: _propTypes.default.oneOf(['top', 'bottom', "center"]),
  selected: _propTypes.default.bool,
  heading: _propTypes.default.bool,

  /** The action function in case of event. Changes the element to button */
  action: _propTypes.default.func,

  /** nav url */
  to: _propTypes.default.string,

  /** component type */
  component: _propTypes.default.string
};
ListItem.defaultProps = {
  primary: null,
  secondary: null,
  intro: null,
  footerNote: null,
  startAdornment: null,
  endAdornment: null,
  align: "center",
  action: null,
  selected: false,
  heading: false
};
var ListItemAligns = ['top', 'bottom', "center"];
exports.ListItemAligns = ListItemAligns;
var _default = ListItem;
exports.default = _default;